import React, { useEffect } from 'react';
import SEO from '../components/SEO';
import HeroV2 from '../components/sections/HeroV2';
import ThemeStrip from '../components/sections/ThemeStrip';
import WhatWeDo from '../components/sections/WhatWeDo';
import ProductsShowcase from '../components/sections/ProductsShowcase';
import VisionStory from '../components/sections/VisionStory';
import CTABanner from '../components/sections/CTABanner';

const Home = () => {
  useEffect(() => {
    const hash = window.location.hash;

    // 해시가 있으면 해당 섹션으로 스크롤, 없으면 상단으로 스크롤
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const handleHashChange = () => {
      const currentHash = window.location.hash;
      if (currentHash) {
        const element = document.querySelector(currentHash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const structuredData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': 'https://flowto-ai.com/#organization',
        name: 'Flowto.AI',
        url: 'https://flowto-ai.com',
        logo: 'https://flowto-ai.com/images/og-default.png',
        description:
          'AI 프로덕트 스튜디오. 여행, 건강·습관, 비즈니스 검증, 생활 도구 — 일상에서 쓰는 서비스를 만듭니다.',
        sameAs: ['https://blog.flowto-ai.com'],
      },
      {
        '@type': 'WebSite',
        '@id': 'https://flowto-ai.com/#website',
        url: 'https://flowto-ai.com',
        name: 'Flowto.AI',
        publisher: { '@id': 'https://flowto-ai.com/#organization' },
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: 'https://flowto-ai.com/?s={search_term_string}',
          },
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'BreadcrumbList',
        '@id': 'https://flowto-ai.com/#breadcrumb',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '홈',
            item: 'https://flowto-ai.com',
          },
        ],
      },
    ],
  };

  return (
    <div className="home-page">
      <SEO
        title="작게 만들고, 빠르게 검증합니다"
        description="Flowto.AI는 AI 프로덕트 스튜디오입니다. 여행, 건강·습관, 비즈니스 검증, 생활 도구 — 일상에서 쓰는 서비스를 만듭니다."
        url="/"
        structuredData={structuredData}
      />
      <HeroV2 />
      <ThemeStrip />
      <WhatWeDo />
      <ProductsShowcase layout="home" showAllLink />
      <VisionStory />
      <CTABanner />
    </div>
  );
};

export default Home;
